import axios from 'axios'
import {showToast} from "vant";
// import router from "../router";
import QS from 'qs';

// eslint-disable-next-line no-unused-vars
export function getBaseUrl(url) {
    // if(url.indexOf('router') > -1) {
    //     return 'http://dev.haodianzhu.fun/'
    // }
    // return 'http://hao.haodianzhu.fun/'
    if(url.indexOf('router') > -1) {
        return 'https://mo.haodianzhu.com.cn/'
    }
    return 'https://hao.haodianzhu.com.cn/'
}

const service = axios.create({
    timeout: 5000
})

service.interceptors.request.use(
    config => {
        const sid = localStorage.getItem('sid')
        if (sid) {
            config.headers['sid'] = sid
        }
        config.data = QS.stringify(config.data)
        config.baseURL = getBaseUrl(config.url)
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        return response.data

    },
    error => {
        showToast(error.message)
        return Promise.reject(error)
    }
)

export default service
